import { z } from "zod";

export const PlanSchema = z.enum(["BASIC", "PRO", "ENTERPRISE"]);

export const PaymentOrderResponseSchema = z.object({
	orderId: z.string(),
	amount: z.number(),
	orderName: z.string(),
});

export const PlanPaymentResponseSchema = z.union([
	z.object({ needBillingAuth: z.literal(true), customerKey: z.string() }),
	z.object({ success: z.literal(true) }),
	z.object({ error: z.string(), status: z.number().optional() }),
]);

export const PlanPaymentRequestSchema = z.object({
	plan: PlanSchema,
});

export const GyulPaymentRequestSchema = z.object({
	amount: z.number(),
});

export const ConfirmPaymentRequestSchema = z.object({
	paymentKey: z.string(),
	orderId: z.string(),
	amount: z.number(),
});

export const ConfirmPaymentResponseSchema = z.object({
	success: z.boolean(),
	paymentKey: z.string().optional(),
});

export const PaymentSchema = z
	.object({
		id: z.string().cuid(),
		amount: z.number(),
		status: z.string(),
		type: z.string(),
		createdAt: z.string().datetime().optional(),
		gyulAmount: z.number().optional(),
	})
	.passthrough();

export const PaymentHistoryResponseSchema = z.object({
	payments: z.array(PaymentSchema),
	total: z.number(),
	page: z.number(),
	limit: z.number(),
});

export type Plan = z.infer<typeof PlanSchema>;
export type PaymentOrderResponse = z.infer<typeof PaymentOrderResponseSchema>;
export type PlanPaymentResponse = z.infer<typeof PlanPaymentResponseSchema>;
export type PlanPaymentRequest = z.infer<typeof PlanPaymentRequestSchema>;
export type GyulPaymentRequest = z.infer<typeof GyulPaymentRequestSchema>;
export type ConfirmPaymentRequest = z.infer<typeof ConfirmPaymentRequestSchema>;
export type ConfirmPaymentResponse = z.infer<typeof ConfirmPaymentResponseSchema>;
export type Payment = z.infer<typeof PaymentSchema>;
export type PaymentHistoryResponse = z.infer<typeof PaymentHistoryResponseSchema>;
